const white = "rgba(255,255,255,1)";
let red = {
  "50": "rgba(254,231,229,1)",
  "100": "rgba(253,209,203,1)",
  "200": "rgba(250,165,153,1)",
  "300": "rgba(247,120,102,1)",
  "400": "rgba(243,76,53,1)",
  "500": "rgba(226,43,18,1)",
  "600": "rgba(192,25,2,1)",
  "700": "rgba(145,17,0,1)",
  "800": "rgba(97,12,0,1)",
  "850": "rgba(72,8,0,1)",
  "900": "rgba(48,6,0,1)",
  "950": "rgba(23,3,0,1)"
};
let yellow = {
  "50": "rgba(255,247,232,1)",
  "100": "rgba(255,239,210,1)",
  "200": "rgba(255,224,165,1)",
  "300": "rgba(255,208,120,1)",
  "400": "rgba(255,193,75,1)",
  "500": "rgba(255,178,30,1)",
  "600": "rgba(218,146,10,1)",
  "700": "rgba(159,107,5,1)",
  "800": "rgba(111,74,3,1)",
  "850": "rgba(83,55,2,1)",
  "900": "rgba(55,37,0,1)",
  "950": "rgba(27,18,0,1)"
};
let green = {
  "50": "rgba(232,247,241,1)",
  "100": "rgba(211,238,227,1)",
  "200": "rgba(167,222,199,1)",
  "300": "rgba(124,204,171,1)",
  "400": "rgba(82,186,144,1)",
  "500": "rgba(40,168,120,1)",
  "600": "rgba(30,136,92,1)",
  "700": "rgba(22,102,70,1)",
  "800": "rgba(14,69,47,1)",
  "850": "rgba(10,52,36,1)",
  "900": "rgba(5,35,22,1)",
  "950": "rgba(2,17,11,1)"
};
let blue = {
  "50": "rgba(229,245,253,1)",
  "100": "rgba(200,237,255,1)",
  "200": "rgba(153,217,248,1)",
  "300": "rgba(92,201,255,1)",
  "400": "rgba(51,179,242,1)",
  "500": "rgba(0,173,239,1)",
  "600": "rgba(0,128,191,1)",
  "700": "rgba(0,96,143,1)",
  "800": "rgba(0,64,95,1)",
  "850": "rgba(0,47,71,1)",
  "900": "rgba(0,32,47,1)",
  "950": "rgba(0,16,23,1)"
};
let slate = {
  "50": "rgba(238,241,244,1)",
  "100": "rgba(222,228,233,1)",
  "200": "rgba(189,202,211,1)",
  "300": "rgba(156,174,189,1)",
  "400": "rgba(124,147,166,1)",
  "500": "rgba(101,121,135,1)",
  "600": "rgba(73,96,115,1)",
  "700": "rgba(54,72,87,1)",
  "800": "rgba(35,49,59,1)",
  "850": "rgba(26,37,44,1)",
  "900": "rgba(17,25,29,1)",
  "950": "rgba(8,13,15,1)"
};
let grayscale = {
  "0": white,
  "50": "rgba(239,239,239,1)",
  "100": "rgba(224,224,224,1)",
  "200": "rgba(193,193,193,1)",
  "300": "rgba(163,163,163,1)",
  "400": "rgba(132,132,132,1)",
  "500": "rgba(102,102,102,1)",
  "600": "rgba(81,81,81,1)",
  "700": "rgba(61,61,61,1)",
  "800": "rgba(40,40,40,1)",
  "850": "rgba(30,30,30,1)",
  "900": "rgba(20,20,20,1)",
  "950": "rgba(10,10,10,1)"
};
let purple = {
  "50": "rgba(239, 234, 250, 1)",
  "100": "rgba(222, 213, 245, 1)",
  "200": "rgba(193, 173, 237, 1)",
  "300": "rgba(166, 134, 235, 1)",
  "400": "rgba(138, 94, 232, 1)",
  "500": "rgba(116, 62, 217, 1)",
  "600": "rgba(94, 29, 201, 1)",
  "700": "rgba(73, 23, 157, 1)",
  "800": "rgba(52, 16, 112, 1)",
  "900": "rgba(31, 15, 65, 1)"
};

export { blue, grayscale, green, purple, red, slate, white, yellow };
